import React, {createContext, useContext, type Dispatch, type SetStateAction} from "react";
import type {IUser} from "@buildwitt/shapeshift-types";

export type App2AuthUser = IUser & {
	profileImage: string;
	organizationId?: string;
	organizationName?: string;
	externalId?: string;
};

export interface App2AuthContextValue {
	/** Initial storage / bootstrap finished (logged in or out). */
	authReady: boolean;
	jwt: string | undefined;
	setJwt: (token: string) => void;
	user: App2AuthUser | undefined;
	setUser: Dispatch<SetStateAction<App2AuthUser | undefined>>;
	authenticated: boolean;
	config: {baseApiUrl: string};
	logout: () => void;
	/** Start PropelAuth OAuth (or complete exchange if `?code=` is present). */
	loginWithOAuth: () => Promise<void>;
	onUauthorizedResponse: () => void;
	onNetworkError: () => void;
}

export const App2AuthContext = createContext<App2AuthContextValue | undefined>(undefined);

export function useApp2Auth(): App2AuthContextValue {
	const v = useContext(App2AuthContext);
	if (v === undefined) {
		throw new Error("useApp2Auth must be used within AuthProvider");
	}
	return v;
}
